import { render } from "./SubmissionConfirmationCreativeSetting.vue?vue&type=template&id=4099d573&scoped=true"
import script from "./SubmissionConfirmationCreativeSetting.vue?vue&type=script&lang=js"
export * from "./SubmissionConfirmationCreativeSetting.vue?vue&type=script&lang=js"

import "./SubmissionConfirmationCreativeSetting.vue?vue&type=style&index=0&id=4099d573&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4099d573"]])

export default __exports__